import React from "react";
import "./SuperStack.css";
import { Link } from "react-router-dom";


const stackData = [
  {
    title: "Creator Hub",
    subtitle: "5 Diverse Program",
    successRate: "93% land biz roles or launch ventures",
    tag: "Business",
    footer: "Graphic Design · UI/UX · Psychology · Content creation · UI/UX",
    bgImage: require("../assets/1sttt.png"),
  },
  {
    title: "Core Tech",
    subtitle: "5 Diverse Program",
    successRate: "90% land tech roles or launch products",
    tag: "Tech",
    footer: "Artificial Intelligence · Data Science · Cloud Computing  · Machine Learning · Web Development",
    bgImage: require("../assets/2nd.png"),
  },
  {
    title: "Medical Edition",
    subtitle: "3 Diverse Program",
    successRate: "84% gain  confidence to pursue future careers in medical.",
    tag: "Medical",
    footer: "Medical coding · Gentic engineering  · psychology · Medical coding · Gentic engineering · psychology  ",
    bgImage: require("../assets/3rdd.png"),
  },
  {
    title: "Startup-Stack",
    subtitle: "7 Diverse Program",
    successRate: "91% gain  confidence to lead market trends.",
    tag: "Trending",
    footer: "Business Analytics · Human Resource · Stock market · Finance · Psychology · Digital Marketing ",
    bgImage: require("../assets/3rdd.png"),
  },
];

const SuperStack = () => {
  return (
    <section className="stack-wrapper" id="stack-navigate">
      <div className="best-heading-section">
        <hr className="lefst" id="lefstack" />
        <h1>
          Super <span className="proo">Stack </span>
        </h1>
        <hr className="rig" id="lefstack" />
      </div>
      <p className="stackland-subheading">All-in-one bundles to grow and create</p>
      <div className="stack-card-container">
        {stackData.map((item, index) => (
          <Link className="navlink"
              to={`/${item.title.toLowerCase().replace(/\s+/g, "-")}`}
            >
          <div
            className="stack-box"
            key={index}
            style={{ backgroundImage: `url(${item.bgImage})` }}
          > 
            
            <div className="overlay">
              <div className="stack-tag">{item.tag}</div>
              <h3 className="stack-title">{item.title}</h3>
              <p className="stack-subn">{item.subtitle}</p>
              <p className="stack-rate">
                <strong ><span className="success">Success rate:</span></strong><br className="next"/>
                {item.successRate}
              </p>
              <button className="stack-learn">
                <img src={require("../assets/arrows.png")} alt="arrow" className="arrow-icon" />
              </button>
            </div>
            <div className="stack-footer-scroll">
              <div className="scroll-content">{item.footer} · {item.footer}</div>
            </div>
            
          </div>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default SuperStack;
